var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileImageSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile-image",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_172",
    "data-name": "Ellipse 172",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#ddebed"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 6.881,
    cy: 6.881,
    r: 6.881,
    transform: "translate(17.119 10.967)",
    fill: "#f5fbfc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M8.216,27.036a.826.826,0,0,0,.242.722,18.131,18.131,0,0,0,25.3,0A.826.826,0,0,0,34,27.036,10.806,10.806,0,0,0,23.321,17.9H18.892A10.806,10.806,0,0,0,8.216,27.036Z",
    transform: "translate(2.894 9.244)",
    fill: "#f5fbfc",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImageSmall);
export default __webpack_public_path__ + "static/media/profile-image-small.8defad76e7b290e57f5b79b630d84503.svg";
export { ForwardRef as ReactComponent };